/**
 * Transform an object of key => primitives values to a query string
 * @param params
 * @return {string}
 */
export function generateQueryString(params) {
  let query = "";
  const encodeValue = (k, v) => Array.isArray(v) ? v.map(r => encodeValue(k, r)).join("&") :`${encodeURIComponent(k)}=${encodeURIComponent(v)}`;
  const vars = Object.keys(params).map(key => {
    return (typeof params[key] !== "undefined" && params[key] !== null) && (encodeValue(key, params[key]));
  }).filter(Boolean);

  if( vars.length > 0 ) {
    query = `?${vars.join("&")}`;
  }

  return query;
}
